import { BaseRouteService } from "./BaseRouteService";

export class TimerService extends BaseRouteService {
    public async getRemainingTime(): Promise<{ remainingSeconds: number; expired: boolean }> {
        return await this.getJsonApi("game/timer");
    }
}
